<template>
  <b-row
    align-h="between"
    align-v="center"
    class="w-100 "
    @mouseover="onHover"
    @mouseleave="onLeave"
  >
    <b-col
      md="auto"
    >
      {{ controller.text }}:
    </b-col>
    <b-col
      class="p-0 m-0"
    >
      <SimpleDropdownConfiguration
        :controller="controller"
        :disabled="disabled"
      />
    </b-col>
  </b-row>
</template>

<script>
import SimpleDropdownConfiguration from './SimpleDropdownConfiguration'
import { mapActions } from 'vuex'

export default {
  name:'DropdownConfiguration',
  components: { 
    SimpleDropdownConfiguration
  },
  props: {
    controller:{
      type:Object,
      required: true
    },
    disabled:{
      type:Boolean,
      required:false,
      default: false
    }
  },
  methods: { 
    ...mapActions(['setContextOnHover']),
    onHover() {
      if(this.controller.contextHelp!==null){
        this.setContextOnHover(this.controller.contextHelp)
      }
    },
    onLeave(){
      if(this.controller.contextHelp!==null){
        this.setContextOnHover(null)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>